<template>

  <w-dialog
    v-model="dialog.show"
    :fullscreen="dialog.fullscreen"
    :width="dialog.width"
    :persistent="dialog.persistent"
    :persistent-no-animation="dialog.persistentNoAnimation"
    title-class="primary-light1--bg white">
    <template #title>
      <w-icon class="mr2">fal fa-cog</w-icon>
      Menu
    </template>

    <w-form 
      ref="form" 
      v-model="dialog.valid"
      @validate="submit"
      @success="success"
    >
    <z-lookup 
      label="Modul"
      name="module"
      url="admin.modulelookup"
      :sort="false"
      :cache="false"
      
      v-model="form.module_id"
    />
    <z-input label="Label" v-model="form.label" name="name" :validators="[validators.required]" />
    <w-flex justify-center align-center>
    <z-input label="Icon" v-model="form.icon" name="icon" :validators="[validators.required]" class="box xs11" />
    <w-icon xl class="box xs1">
    {{ form.icon }}
    </w-icon>
    </w-flex>
    <z-input label="Route" v-model="form.route" name="route" :validators="[validators.required]" />
    <z-input label="Order" v-model="form.sort" name="sort" :validators="[validators.required]" />

    </w-form>

    
    <template #actions>
      <div class="spacer" />
      <w-button bg-color="grey-light5--bg" @click="dialog.show = false">Tutup</w-button>
      <w-button 
      class="ml1" 
      :loading="dialog.loading"
      :disabled="dialog.valid === false"
      @click="$refs.form.validate()"
      >
        Simpan
      </w-button>
    </template>    
  </w-dialog>

  <z-table
    ref="tbluser"
    title="Senarai Menu"
    :headers="table.headers"
    :items="table.items"
    :meta="table.meta"
    :filter="ffilter(search)"
    class=""
  >

    <template #button>
      <w-button 
      dark
      class="indigo-dark2--bg ml1 fs-2" 
      @click="newrecord()"
      >
        <w-icon class="mr1" xs>fal fa-plus</w-icon> Cipta 
      </w-button>
    </template>

    <template #zfilter>
      <z-lookup 
        label="Modul"
        name="module"
        class="table-bar-lookup"
        url="admin.modulelookup"
        :sort="false"
        :cache="false"
        v-model="search.module_id"
      />

      <w-input
        v-model="search.keyword"
        label="Tapis maklumat"
        placeholder="Sila Masukkan maklumat yang ingin ditapis..."
        inner-icon-left="wi-search"
        class="xs11 table-bar-input">
      </w-input>

      <w-button
        class="btn-search"
        @click="searchadvance = !searchadvance"
      >
              <w-icon>fal fa-sliders-v</w-icon>
      </w-button>

      <w-button
        class="btn-search"
        @click="searchreset"
      >
        <w-icon>fal fa-redo</w-icon>
      </w-button>

      <w-button
        class="btn-search pr3"
      >
        <w-icon>fal fa-search</w-icon>
      </w-button>

      
    </template>

    <template #zslider>
    <w-transition-expand>
    <w-card
        v-show="searchadvance"
        class="bd0 table-bar-search-advance"
        >
        <div class="table-bar-search-advance-inner">advance search</div>
      </w-card>
    </w-transition-expand>
      
    </template>
  
    <template #header-label="{ header, label, index }">
      <template v-if="header.key == 'action'">
      <w-icon>fal fa-pencil</w-icon>
      </template>
      <template v-else>
      {{ label }}
      </template>
      
    </template>

    <template #item-cell.icon="{ item, label, header, index }">
      <w-icon md class="mr1" >{{ item.icon }}</w-icon> 
    </template>

    <template #item-cell.action="{ item, label, header, index }">
      <w-flex class="flex justify-center">
        <w-button class="bs fs-2" bg-color="primary-dark1" tile @click="edit(item)">
          <w-icon xs class="mr2">fal fa-pencil</w-icon> Kemaskini
        </w-button>
        <w-button class="fs-2" bg-color="error-dark1" dark tile @click="destroy(item)">
          <w-icon xs class="mr2">fal fa-trash</w-icon> Padam
        </w-button>
        <w-button 
          bg-color="info-dark1" 
          dark
          tile
          :route="$route('admin.menu.show',item.id)"
          class="be fs-2"
        >
          <w-icon xs class="mr2">fal fa-eye</w-icon> Papar
        </w-button>
      </w-flex>
    </template>

  </z-table>

  
</template>

<script>
import _ from 'lodash'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    menu: [Array, Object],
    items: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'admin.menu',
      reload: true,
      form: {
        id: 0,
        label: '',
        icon: '',
        route: '',
        menu_id: 0,
        module_id: 0,
        sort: 0,
      },
      search: {
        module_id: 0,
        keyword: '',
      },
      searchadvance: false,
      ffilter: _.throttle(search => item  => {
        let keyword = search.keyword
        // dynamically get all the cols and concatenate all the columns into a single string for a faster lookup.
        let allCols = ''
        Object.keys(item).forEach(i => allCols += item[i])
        
        // Lookup the keyword variable in the string with case-insensitive flag.
        let module = true
        let regex =  new RegExp(keyword, 'i').test(allCols) 
        if(search.module_id > 0) {
          module = item.module_id == search.module_id
        }
        return regex && module
      }, 100)
    }
  },
  methods: {
    searchreset() {
      this.search.keyword = ''
      this.search.module_id = 0
    }
  },
  watch: {
    form: {
      handler: function () {
        if(this.menu) {
          this.form.menu_id = this.menu.id
        } else {
          this.form.menu_id = 0
        }
      },
      deep: true
    }
  },
  mounted() {
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>